import React from 'react';
import { faMountains } from '@fortawesome/pro-solid-svg-icons/faMountains';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function MountainsSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faMountains} {...props} />;
}
